import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.PageMedia = class PageMedia extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-page-media';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.addEventListeners();

		if (this.isDeferred && this.isVideoMedia) {
			this.activeVideo = new Snappy.Component.VideoPromo(this.element);
			this.activeVideo.render();
		}
	}

	setVars() {
		this.$expandButton = !this.$element.data('videoUrl') && this.$element.find('.featured-media__expand');
		this.title = this.$element.data('title');
		this.isDeferred = this.element.hasAttribute('data-defer-snappy');
		this.isVideoMedia = this.element.hasAttribute('data-fa-video-promo');
	}

	addEventListeners() {
		if (this.$expandButton) {
			this.$expandButton.on('click', this.onExpandClick.bind(this));
		}
	}

	onExpandClick() {
		const $template = this.constructImageElement();

		this.$window.trigger('modal:openModal', {
			title: this.title,
			$view: $template,
			$prevElement: this.$expandButton,
			fullscreen: true
		});
	}

	constructImageElement() {
		const $copy = this.$element.find('picture').clone();
		const $element = $('<div>').append($copy);

		return $element;
	}
};



// WEBPACK FOOTER //
// ./components/pageMedia/scripts/pageMedia.js